/** Chart.js external tooltips are appended to document.body and persist after navigation. */
export function hideChartJsTooltip() {
    const tooltipEl = document.getElementById('chartjs-tooltip');
    if (tooltipEl) {
        tooltipEl.style.opacity = '0';
        tooltipEl.style.display = 'none';
    }
}

/** Hide chart tooltips and any dashboard hover tooltips left open (common on mobile). */
export function dismissFloatingTooltips() {
    hideChartJsTooltip();
    document.querySelectorAll('.hover-tooltip').forEach((el) => {
        el.style.display = 'none';
    });
}
